import { useAppDispatch, useAppSelector } from '~/common/stores';
import {
  setIsNavBarActive,
  setThemeMode,
  toggleLoading,
  toggleSidebar,
} from '~/common/stores/layout.slice';
import { ThemeMode } from '~/common/types/theme.type';
import { saveThemeMode } from '~/common/utils/theme.util';

function useLayout() {
  const dispatch = useAppDispatch();
  const state = useAppSelector(state => state.layout);

  /**
   * 테마 모드 변경
   */
  const handleSetThemeMode = (mode: ThemeMode) => {
    saveThemeMode(mode);
    dispatch(setThemeMode(mode));
  };

  /**
   * 테마 모드 토글
   */
  const handleToggleThemeMode = () => {
    const nextMode = state.themeMode === ThemeMode.LIGHT ? ThemeMode.DARK : ThemeMode.LIGHT;
    handleSetThemeMode(nextMode);
  };

  /**
   * 로딩 상태 변경
   */
  const handleToggleLoading = (isLoading: boolean) => {
    dispatch(toggleLoading(isLoading));
  };

  /**
   * 사이드바 토글
   */
  const handleToggleSidebar = () => {
    dispatch(toggleSidebar());
  };

  /**
   * 네비게이션 바 활성화 상태 변경
   */
  const handleSetNavBarActive = (isActive: boolean) => {
    dispatch(setIsNavBarActive(isActive));
  };

  return {
    state,
    handleSetThemeMode,
    handleToggleThemeMode,
    handleToggleLoading,
    handleToggleSidebar,
    handleSetNavBarActive,
  };
}

export default useLayout;
